import { render, staticRenderFns } from "./ModificarCliente.vue?vue&type=template&id=7ea84941&scoped=true"
import script from "./ModificarCliente.vue?vue&type=script&lang=js"
export * from "./ModificarCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea84941",
  null
  
)

export default component.exports